import { CallbackParams } from '../../models';
import { GithubAuthDataService } from '../../service/github-auth-data.service';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GithubAuthData } from '@jukebox/common';

@Component({
  selector: 'app-githubcallback',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class GithubCallbackComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly githubAuthDataService = inject(GithubAuthDataService);

  constructor() {
    this.route.queryParams
      .pipe(takeUntilDestroyed())
      .subscribe((queryParams) => this.performLogin(queryParams));
  }

  private async navigateToLoginError() {
    await this.router.navigate(['/logout'], {
      queryParams: { error: 'loginError' },
    });
  }

  private async performLogin(queryParams: Params) {
    try {
      const data = JSON.parse(
        decodeURIComponent(queryParams.state as string),
      ) as CallbackParams;
      const domain = data.domain;

      const authData: GithubAuthData =
        await this.githubAuthDataService.fetchTokenFromGithubAndStoreIt(
          queryParams.code,
          domain,
        );

      if (authData.access_token) {
        window.onbeforeunload = () => {
          (window.opener as Window).postMessage('hsp.github.callback.finished');
        };
        window.close();
      } else {
        await this.navigateToLoginError();
      }
    } catch (_e) {
      await this.navigateToLoginError();
    }
  }
}
